import React, { useState } from 'react';
import { Button, ButtonGroup } from 'reactstrap';
import classnames from 'classnames';
import './customersHeader.scss';
import SearchInput from '../Inputs/SearchInput';
import { safeMobxInject } from '../../stores/storeInjectionHelpers';
import NewCustomerPopupButton from './../../components/redirect/NewCustomerPopup/NewCustomerPopupButton';
import NewCustomerPopup from '../../components/redirect/NewCustomerPopup/NewCustomerPopup';
import MyLightProBanner from './HeaderBanners/MyLightProBanner';
import AlertPopup from './../AlertPopup/AlertPopup';

interface IProps {
  selected: string;
  searchQuery: string;
  toggleView: (view: string) => void;
  searchInputChange: (view: string) => void;
}

interface IStoresProps {
  searchRule: string;
  setSearchRule: (rule: string) => void;
}

const CustomersHeader = safeMobxInject<IStoresProps, IProps>(
  ({ Store: { customersList } }) => ({
    searchRule: customersList.searchRule,
    setSearchRule: customersList.setSearchRule
  }),
  ({
    selected,
    toggleView,
    searchRule,
    setSearchRule
  }: IProps & IStoresProps) => {
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const onTogglePopup = () => setShowPopup(!showPopup);

    return(
      <>
        <div className="customers-header">

          <AlertPopup />

          <div className="customers-header__buttons">
            <ButtonGroup>
              <Button
                onClick={() => {
                  toggleView('list');
                }}
                className={classnames('toggle', { selected: selected === 'list' })}
              >
                <i className="icon-list" />
              </Button>
              <Button
                onClick={() => {
                  toggleView('map');
                }}
                className={classnames('toggle', { selected: selected === 'map' })}
              >
                <i className="icon-map" />
              </Button>
            </ButtonGroup>
            <div className="customers-header-buttons">
              {selected === 'list' && (
                <SearchInput
                  searchInputChange={setSearchRule}
                  searchQuery={searchRule}
                />
              )}
              <div className="add-customer">
                <NewCustomerPopupButton
                  onClick={ onTogglePopup } />
              </div>
            </div>
          </div>
          
        </div>

        { showPopup && <NewCustomerPopup onClose={ onTogglePopup } /> }
      </>
  );}
);
export default CustomersHeader;
